import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/CreateClinic.css";
import { useClinic } from "../../context/ClinicContext";

export default function CreateClinic() {
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    name: "",
    website: "",
    admin: "",
    address: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const { setClinicId } = useClinic();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/create-clinic`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
      console.log("API result:", result);
  
      if (response.ok && result.clinic && result.clinic.id) {
        const clinicId = result.clinic.id;
  
        alert("✅ New clinic created successfully!");
  
        // ✅ Set clinicId in global context
        setClinicId(clinicId);
  
        // ✅ Navigate to Customize Chatbot with token in URL
        navigate(`/admin/customize-chatbot?token=${clinicId}`);
      } else {
        alert("❌ Failed to create clinic: " + (result.detail || "Missing clinic ID"));
      }
    } catch (error) {
      console.error("Error creating clinic:", error);
      alert("❌ Unexpected error. Please try again.");
    }
  };
  
  

  return (
    <div className="create-clinic-page">
      {/* Header: logo + button */}
      <div className="header">
        <img src="/logo.png" alt="Olumis AI Logo" className="logo" />
        <button className="all-clinics-btn" onClick={() => navigate("/admin/all-clinics")}>
          All Clinics
        </button>
      </div>

      {/* Clinic Form */}
      <div className="form-wrapper">
      <form className="clinic-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Clinic Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Clinic Website</label>
          <input type="text" name="website" value={formData.website} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Clinic Admin</label>
          <input type="text" name="admin" value={formData.admin} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Address</label>
          <input type="text" name="address" value={formData.address} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>

        <button type="submit" className="create-btn">Create New Clinic</button>
      </form>
      </div>
    </div>
  );
}

